import { get } from 'svelte/store';
import { readableWritable } from '../shared/storeUtilities';
class StateMachine {
    constructor(state) {
        ({ read: this._readOnlyState, write: this._state } = readableWritable(state));
    }
    get currentState() {
        return this._readOnlyState;
    }
    setState(state) {
        get(this._state).exit();
        this._state.set(state);
        get(this._state).enter();
    }
}
export { StateMachine };
